module.exports = __webpack_public_path__ + "static/mobile-screenshare2-8b2ff5f16ec6dbddf7058109550d9030.png";